<template>
  <options-card-wrapper>
    <!-- Will be switch case service flow  -->
    <!-- switch(service_flow) -->
    <!-- case: 'hpp' -->

    <!----------------------------------  FLOW: HPP  ------------------------------------------>
    <MethodOptionSelectWrapper>
      <div v-if="!isInvoiceFlowDataShown">
        <styledMethodOptionsCard
          v-if="!isLoadingRedirect"
          :is-only-one-service="isOnlyOneService"
          :method="currentPaymentMethod"
        />
        <div v-if="!isOnlyOneService" class="flow-redirect-component">
          <ul class="flow-redirect-component__items">
            <li
              v-for="(item, key) in paymentMethodServices"
              :key="key"
              :class="{
                active: item.currency === (selectedService || {}).currency,
                disabled: item.disabled,
              }"
              @click="
                () => {
                  (currentMethod = item), selectService(item);
                }
              "
            >
              {{ item.currency }}
            </li>
          </ul>
        </div>

        <div v-if="fields.length" class="dpm-fields">
          <div v-for="(field, index) in fields" :key="index" class="dpm-fields__container">
            <styledInputLabel class="dpm-fields__label">{{ $t(field.key) }}</styledInputLabel>
            <styledInput
              @keyup.native.enter="handlePaymentCreate"
              v-model.trim="fieldData[field.key]"
              class="dpm-fields__field"
              :required="field.required"
              :class="setClass(field.key)"
              @input="checkValidation"
              :placeholder="field.example"
            />
          </div>
        </div>

        <styledButton
          :is-disabled="!isServiceSelected || !valid"
          :button-label="PayButtonLabel"
          :is-loading="isLoading"
          :class-names-prop="['btn', 'btn--lrg']"
          @click="handlePaymentCreate"
        />
      </div>

      <!----------------------------------  FLOW: INVOICE  ---------------------------------------->
      <styled-invoice-flow-page v-else />

      <styled-loading-stub v-if="isLoadingRedirect">
        <template v-slot:icon>
          <!-- TODO: Fix logo as componentd with basic stub if no img source exists -->
          <div :style="logoStyles(currentPaymentMethod)" />
        </template>
        <template v-slot:title>{{ $t('now_redirect_to_pg') }}</template>
      </styled-loading-stub>

      <styled-loading-stub v-if="isLoadingInvoiceFlow">
        <template v-slot:icon>
          <div :style="logoStyles(currentPaymentMethod)" />
        </template>
      </styled-loading-stub>
    </MethodOptionSelectWrapper>
  </options-card-wrapper>
</template>

<script>
import MethodOptionsCard from '@/pages/FlowRedirectPage/components/MethodOptionsCard';
import ServiceOptionsList from '@/pages/FlowRedirectPage/components/RadioButtonsList';
import redirectFlowBehavior from '@/behaviors/redirectFlow';
import invoiceFlowBehavior from '@/behaviors/invoiceFlow';
import InvoiceFlowPage from '@/pages/InvoiceFlowPage';
import LoadingStub from '@/components/UI/LoadingStub';
import StructCaller from '@/helpers/structInterface';
import PaymentTabSelectComponent from '@/components/Header/NavigationBar/PaymentTabSelectComponent';
import Button from '@/components/UI/Button';
import cloneDeep from 'lodash/cloneDeep';

import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import styled from 'vue-styled-components';

const styledInputLabel = styled('div', {})`
  color: ${props => props.theme.on_background};
`;

const styledInput = styled('input', '')`
  background: ${props => props.theme.background};
  color: ${props => props.theme.on_background};
`;

const styledLoadingStub = styled(LoadingStub)`
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.on_background};
`;

const styledButton = styled(Button)`
  background-color: ${props => props.theme.primary};
  color: ${props => props.theme.on_primary};
  &:hover {
    transition: ${props => props.theme.default_transition};
    background-color: ${props => props.theme.primary_variant};
  }
`;

const styledServiceOptionsList = styled(ServiceOptionsList)`
  .list-item__wrapper {
    padding: 10px 20px;
    cursor: pointer;
    text-align: left;
    transition: background-color ${props => props.theme.easing};

    &:hover {
      background-color: ${props => props.theme.placeholder_text_color};
      background-color: #d7d9dc;
      transition: background-color ${props => props.theme.easing};
    }
  }
  .list-item__title {
    font-weight: bold;
  }
`;

const styledPaymentTabSelectComponent = styled(PaymentTabSelectComponent)`
  @media screen and (min-width: 769px) {
    .payment-methods__tabs-wrapper--mobile {
      display: none;
    }
  }
  @media screen and (max-width: 769px) {
    .payment-methods__tabs-wrapper--mobile {
      display: block;
    }
    .payment-methods__tabs-wrapper--desktop {
      display: none;
    }
  }
`;

const styledMethodOptionsCard = styled(MethodOptionsCard)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .method-options-card-header__icon {
    width: 5em;
    margin: 1em;
  }
  .method-options-card-header__description {
    font-weight: bold;
    padding: 1em;
    padding-top: 0;
  }
  h5 {
    margin: 0;
  }
`;

const OptionsCardWrapper = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;

  @media screen and (max-width: 769px) {
    padding: 0 20px;
    width: 100%;
  }
`;
const MethodOptionSelectWrapper = styled.section`
  width: 100%;

  .flow-redirect-component__items {
    li {
      background-color: ${props => props.theme.primary};
      color: ${props => props.theme.on_primary};

      opacity: 0.4;

      &:nth-child(1) {
        border-bottom-left-radius: ${props => props.theme.border_radius};
        border-top-left-radius: ${props => props.theme.border_radius};
      }
      &:last-of-type {
        border-top-right-radius: ${props => props.theme.border_radius};
        border-bottom-right-radius: ${props => props.theme.border_radius};
      }

      &.disabled {
        opacity: 0.3;
        color: ${props => props.theme.on_background};
        background-color: ${props => props.theme.background};
        pointer-events: none;
      }

      &.active {
        background-color: ${props => props.theme.primary};
        color: ${props => props.theme.on_primary};
        box-shadow: none;
        opacity: 1;
      }

      &:hover {
        &:not(.active) {
          color: ${props => props.theme.on_primary};
          opacity: 0.6;
        }
      }
    }
  }
  .method-options-card-header__description {
    color: ${props => props.theme.primary_text_color};
  }
`;

const MethodOptionSelect = styled.section`
  background: ${props => props.theme.secondary_background_color};
  width: 50%;
  border-radius: 4px;
  padding: 4em;
`;

const styledInvoiceFlowPage = styled(InvoiceFlowPage)`
  color: ${props => props.theme.primary_text_color};
  background: ${props => props.theme.secondary_background_color};
`;

export default {
  components: {
    OptionsCardWrapper,
    MethodOptionSelectWrapper,
    styledMethodOptionsCard,
    styledButton,
    styledLoadingStub,
    styledInputLabel,
    styledInput,
    styledInvoiceFlowPage,
  },

  data() {
    return {
      isServiceSelected: false,
      currentMethod: {},
      validatedFields: [],
      fieldData: {},
      isLoading: false,
      isLoadingRedirect: false,
      isLoadingInvoiceFlow: false,
    };
  },

  watch: {
    selectedService: 'initLocalState',
  },

  async created() {
    try {
      this.initLocalState();
      // We can have data to process in state, or query string
      if (this.autoProcessData && this.autoProcessData.service) {
        // Select presetted service
        await this.selectService(this.autoProcessData.service);
      } else {
        // If  no preseted - select first;
        if (this.paymentMethodServices && this.paymentMethodServices.length) {
          await this.selectService(this.paymentMethodServices[0]);
        }
      }

      if (
        (this.autoProcessData || {}).autoProcess ||
        (this.currentPaymentMethod || {}).autoProcess
      ) {
        console.log('Will be fired autopr');
        this.autoProcess();
      }
    } catch (e) {
      console.log('Too much pain', e);
    }
  },

  methods: {
    ...mapActions(['selectService', 'setAutoProcessData', 'setGlobalError', 'disableMethod']),
    ...mapActions('UI', ['ADD_MESSAGE']),

    ...mapMutations(['SET_CURRENT_STEP', 'SET_INVOICE_FLOW_DATA_SHOWN']),

    async validateAmount() {
      const service = this.selectedService;
      console.log(parseFloat(service.amount_min), parseFloat(service.amount_max));
      if (
        service.hasOwnProperty('amount_min') &&
        service.hasOwnProperty('amount_max') &&
        !Number.isNaN(parseFloat(service.amount_min)) &&
        !Number.isNaN(parseFloat(service.amount_max))
      ) {
        this.validAmount =
          parseFloat(this.invoiceInitialData.amount) >= parseFloat(service.amount_min) &&
          parseFloat(this.invoiceInitialData.amount) <= parseFloat(service.amount_max);
        if (!this.validAmount) {
          return Promise.reject({
            code: 'invalid_amount',
          });
        }
      } else {
        return Promise.resolve({
          code: 'amount_valid',
        });
        this.validAmount = true;
      }
    },

    logoStyles(method) {
      return {
        'min-height': '5em',
        width: '5em',
        'background-image': `url(${method.logo})`,
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'background-size': 'contain',
      };
    },

    // TODO: Refactor this. Move logic to error handler in behaviors.
    async handlePaymentCreate() {
      this.checkValidation();
      this.isLoading = true;

      try {
        /*
         *  invoice flow
         * */
        if ((this.selectedService || {}).flow === 'invoice') {
          await this.makeInvoiceFlowPayment(this.selectedService, this.fieldData);
        } else {
          /*
           *  hpp flow
           * */

          /**
           * Sanitize fields
           */
          const readyFields = cloneDeep(this.fieldData);
          this.fields.forEach(({ key, required }) => {
            const isEmpty = ['', null, undefined].includes(readyFields[key]);
            if (!required && isEmpty) {
              delete readyFields[key];
            }
          });

          await this.makePayment(this.selectedService, readyFields);
        }
      } catch (e) {
        this.SET_CURRENT_STEP(1);
        // Handle error if no payload to redirect (fields)
        console.log('Error ddfsdfsdf', e);

        if (e.name === 'RedirectPayloadError') {
          this.disableService();

          const erorrStruct = StructCaller.getStructData('ERRORS', 'code', 'service_unavailable');

          console.log('Errors strcit', erorrStruct);

          this.ADD_MESSAGE({
            text: erorrStruct.translations.title[(this.$i18n || {}).locale || 'en'],
            additionalInfo: erorrStruct.translations.details[(this.$i18n || {}).locale || 'en'],
            type: 'error',
          });

          if (!this.checkAvailableServices()) {
            this.disableMethod(this.selectedMethod);
            this.$router.push({
              name: 'PaymentMethodsListPage',
            });
          } else {
            this.selectFirsAvailableService();
          }
          console.log(e);
        } else {
          if ((e.response.data || {}).errors) {
            console.log('Got Error');
            const ErrorObject = (e.response.data || {}).errors;
            for (const [k, v] of Object.entries(ErrorObject)) {
              this.ADD_MESSAGE({
                text: this.$t(k),
                additionalInfo: v,
                type: 'error',
              });
            }
          } else if (e.response && e.response.code && e.response.code === 503) {
          } else {
            // Handle error struct call
            const erorrStruct = StructCaller.getStructData(
              'ERRORS',
              'code',
              e.response.code || 'default'
            );

            this.ADD_MESSAGE({
              text: erorrStruct.translations.title[(this.$i18n || {}).locale || 'en'],
              additionalInfo: erorrStruct.translations.details[(this.$i18n || {}).locale || 'en'],
              type: 'error',
            });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     *  Method takes current selected service, and disable UI.
     * If Current method has all services disabled - the user will be redirected on method list
     * and the method without available services will be disabled too.
     *
     */
    disableService() {
      this.selectedService.disabled = true;
    },

    checkAvailableServices() {
      return this.paymentMethodServices.find(s => s.disabled === false);
    },

    selectFirsAvailableService() {
      console.log('Serivce ok', this.paymentMethodServices, this.selectedService);
      const serviceToSelect = this.paymentMethodServices.find(
        s => s.code != this.selectedService.code && s.disabled === false
      );

      if (serviceToSelect) {
        this.selectService(serviceToSelect);
      } else {
        throw { name: 'no-availavle-services' };
      }
    },

    setClass(key) {
      if (this.validatedFields.length > 0) {
        return !this.validatedFields.find(field => field.key === key && !field.valid)
          ? 'dpm-fields__field--valid'
          : 'dpm-fields__field--invalid';
      } else {
        return '';
      }
    },

    async autoProcess() {
      console.log(this.presettedFields);
      // 1) Проверяем пришли ли поля от юзера по кверию
      // 2) Если нет, то смотрим есть ли поля в данном сервисе
      // 3) Если полей у сервиса нет - процессим
      //TODO: make types helper to handle type care
      if (this.presettedFields && _.isArray(this.presettedFields) && this.presettedFields.length) {
        this.presettedFields.forEach(f => {
          // Map presseted fileds from query on  current service fields
          console.log('Got some felds:', f, f.key, this.fieldData, this.fieldData[f.key]);

          if (f.key in this.fieldData) {
            this.fieldData[f.key] = f.value;
          }
        });
      }

      await this.checkValidation();
      if (this.valid) {
        this.handlePaymentCreate();
      } else {
        console.error('Invalid fields', this.valid);
      }
    },

    initLocalState() {
      this.validatedFields = [];
      this.fieldData = {};
      this.isServiceSelected = true;

      if (this.fields.length > 0) {
        this.fields.forEach(f => {
          this.$set(this.fieldData, [f.key], '');
        });
      }
    },

    checkValidation() {
      return new Promise((resolveValidation, rejectValidation) => {
        if (!!this.fields && this.fields.length > 0) {
          let valid = [];
          // This thing is working async
          const fieldsValidate = this.fields.map(f => {
            return new Promise((res, rej) => {
              const key = f.key;

              if (f.required) {
                valid.push({
                  valid: (this.fieldData[f.key] || []).length > 0 ? true : false,
                  key,
                });
              } else {
                valid.push({ key, valid: true });
              }

              if (f.regexp && f.regexp.length > 0) {
                valid.push({
                  valid: !!this.fieldData[f.key].match(new RegExp(f.regexp.replace(/\\\\/g, '\\'))),
                  key,
                });
              }

              res(true);
            });
          });

          Promise.all(fieldsValidate).then(res => {
            this.validatedFields = valid;
            resolveValidation(valid);
          });
        } else {
          this.validatedFields = [];
          resolveValidation([]);
        }
      });
    },
  },
  computed: {
    ...mapState([
      'methods',
      'services',
      'selectedService',
      'autoProcessData',
      'selectedMethod',
      'invoiceInitialData',
      'isInvoiceFlowDataShown',
      'paymentInvoiceData',
    ]),

    ...mapState('UI', ['customThemeOptions']),

    ...mapGetters(['extendedMethods']),

    isOnlyOneService() {
      return this.paymentMethodServices.length === 1;
    },

    /**
     * If only one service - we must show the currency on the pay button;
     */

    currentServiceCurrency() {
      return this.paymentMethodServices[0].currency || '';
    },

    PayButtonLabel() {
      const text = this.customThemeOptions.pay_button_label || 'pay';
      return this.isOnlyOneService ? `${this.$t(text)}  ${this.currentServiceCurrency}` : `${text}`;
    },

    currentPaymentMethod() {
      const currentMethod = this.extendedMethods.find(m => {
        return m.code === this.$route.params.pm;
      });

      if (currentMethod) {
        return currentMethod;
      }

      if ((this.methods || {})[this.$route.params.pm]) {
        return this.methods[this.$route.params.pm];
      } else if (
        this.paymentInvoiceData.data &&
        this.paymentInvoiceData.data &&
        this.paymentInvoiceData.data.service_flow === 'invoice'
      ) {
        return { code: this.paymentInvoiceData.data.service_method };
      } else {
        console.log('Payment method doesnt exits', currentMethod, this.$route.params.pm);
        this.setGlobalError({
          code: 'no_existed_route',
        });
        return {};
      }
    },

    fields() {
      return (this.selectedService || {}).fields || [];
    },

    presettedFields() {
      return (this.autoProcessData || {}).service_fields_presetted || [];
    },

    paymentMethodServices() {
      if ((this.services || {})[this.$route.params.pm]) {
        return ((this.services || {})[this.$route.params.pm] || []).map(s => {
          return { ...s, disabled: false };
        });
      } else {
        return [];
      }
    },

    valid() {
      if (this.validatedFields.length > 0 && this.fields.length > 0) {
        return !this.validatedFields.find(field => !field.valid);
      } else if (this.validatedFields.length === 0 && this.fields.length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },

  beforeDestroy() {
    console.log('Destoryed');
    this.fieldData = {};
    this.setAutoProcessData({
      service: '',
      autoProcess: false,
      service_fields_presetted: [],
      sercice_code_presetted: '',
    });
  },

  mixins: [redirectFlowBehavior, invoiceFlowBehavior],
};
</script>
